import { sqlNullTime } from "@/utils/sqltypes"
import { z } from "zod"

// We're keeping a simple non-relational schema here.
// IRL, you will have a schema for your data models.
export const Supplier = z.object({
  id: z.string(),
  name: z.string(),
  pharmacy_code: z.string(),
  created_at: z.string(),
  metadata: z.object({
    phone_number: z.string(),
    contact_person_name: z.string(),
  }),
  credit_terms: z.object({
    is_credit_allowed: z.boolean(),
    credit_period: z.number(),
    monthly_payment_date: z.number(),
  }),
  full_count: z.number().optional(),
})

export const SupplierSearchParams = z.object({
  page: z.number().int().default(1),
  pageSize: z.number().int().default(10),
  search: z.string().optional(),
})

export const SupplierStats = z.object({
  total_purchased: z.number(),
  active_inventory: z.number(),
  sold: z.number(),
  expired: z.number(),
  expiring_soon: z.number(),
})

export const SupplierOutgoingPayments = z.array(
  z.object({
    invoice_id: z.string(),
    invoice_number: z.string(),
    invoice_date: z.string(),
    calculated_payment_date: z.string().nullable(),
    total_amount: z.number(),
    paid: z.boolean(),
    due_this_month: z.boolean(),
    overdue: z.boolean(),
  })
)

export const OneSupplier = z.object({
  supplier: Supplier,
  stats: SupplierStats,
  outgoing_payments: SupplierOutgoingPayments,
})

export type Supplier = z.infer<typeof Supplier>
export type SupplierSearchParams = z.infer<typeof SupplierSearchParams>
export type SupplierStats = z.infer<typeof SupplierStats>
export type OneSupplier = z.infer<typeof OneSupplier>
export type SupplierOutgoingPayments = z.infer<typeof SupplierOutgoingPayments>